exports = module.exports = require("../../node_modules/_css-loader@0.23.1@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".service .service-box{margin-top:30px}.service .service-box h1{margin-top:15px;padding:0 25px;font-size:18px}.service .service-item{padding:10px 0;height:100px;border-bottom:1px solid #f0f0f0;border-right:1px solid #f0f0f0}.service .service-item,.service .service-item a{color:#222}.service .service-item.no-right{border-right:none}.service .service-item.no-bottom{border-bottom:none}.service .service-item img{display:block;margin:10px auto 5px;height:35px}.service .service-item img.more{margin-top:20px;margin-bottom:20px;width:40px;height:10px}.service .service-item p{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.23.1@css-loader!./src/styles/service.css
// module id = 807
// module chunks = 0